/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * Only 'active' is allowed via PATCH (system-only sets 'invalid'). Use this to re-enable a login after fixing the underlying failure.
 */
export type UpdateMeetLoginBodyState =
  (typeof UpdateMeetLoginBodyState)[keyof typeof UpdateMeetLoginBodyState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMeetLoginBodyState = {
  active: "active"
} as const
